<template>
  <section class="site-map">
    <div class="site-map__wrapper">
      <h2 class="site-map__wrapper--title" v-if="$isMobile()">Chapters</h2>
      <div
        class="site-map__wrapper--selection"
        v-for="(selection, i) in selections"
        :key="`selection_${i}`"
        v-scroll-to="{
          el: `#${selection.scroll}`,
          onStart: closeSiteMap,
          duration: 500,
          lazy: false,
          easing: 'linear',
        }"
      >
        <img
          v-if="!$isMobile()"
          :src="require(`../assets/images/${selection.image}.png`)"
        />
        <h5>{{ selection.title }}</h5>
        <p v-if="!$isMobile()">{{ selection.body }}</p>
      </div>
      <!-- <h2 class="site-map__wrapper--title" v-if="$isMobile()">Showcase</h2>
      <h2
        class="site-map__wrapper--title"
        v-if="$isMobile()"
        @click="authenticate"
      >
        {{ loginText }}
      </h2> -->
    </div>
  </section>
</template>

<script>
export default {
  name: 'SiteMap',
  props: {
    selections: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  computed: {
    loginText() {
      return this.authState.isAuthenticated ? 'Sign out' : 'Sign in'
    },
  },
  methods: {
    authenticate() {
      return this.authState.isAuthenticated ? this.logout() : this.login()
    },
    login() {
      this.$auth.signInWithRedirect()
    },
    async logout() {
      await this.$auth.signOut()
      localStorage.removeItem('okta-token-storage')
    },
    closeSiteMap() {
      this.$emit('closeSiteMap')
    },
  },
}
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.site-map {
  width: 100%;
  background-color: var(--color-mozzarella-1);
  position: fixed;
  margin-top: 70px;
  z-index: 2;
  max-height: 100vh;
  overflow-y: scroll;
  &__wrapper {
    display: flex;
    padding: 50px 5%;
    flex-wrap: wrap;
    @media (max-width: $tablet) {
      text-align: center;
    }
    &--title {
      color: var(--color-orange-1);
      @media (max-width: $tablet) {
        margin: 0 auto;
      }
    }
    &--selection {
      cursor: pointer;
      width: 20%;
      margin: 50px 0;
      img,
      h5,
      p {
        width: 90%;
      }
      h5 {
        margin-bottom: -10px;
      }
      &:hover {
        opacity: 0.9;
        transform: scale(1.02);
      }
      @media (max-width: $tablet) {
        width: 50%;
      }
    }
  }
}
</style>